import React from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';

import { spacing } from '../../core/theme/tokens';
import {
  useWidgetInsights,
  type InsightWidgetTarget,
} from '../../hooks/useWidgetInsights';
import type { InsightCard } from '../../services/assistantService';
import { InsightExpandableCard } from './InsightExpandableCard';

type CalloutProps = {
  card: InsightCard;
  widget: InsightWidgetTarget | string;
  style?: StyleProp<ViewStyle>;
};

/**
 * Widget-scoped insight: title on top, OIIA inside, Explore opens chat.
 */
export function WidgetInsightCallout({ card, widget, style }: CalloutProps) {
  return <InsightExpandableCard card={card} widget={widget} style={style} />;
}

type SlotProps = {
  widget: InsightWidgetTarget;
  /** Max cards to show. Default 1. */
  limit?: number;
  enabled?: boolean;
  style?: StyleProp<ViewStyle>;
};

/**
 * Fetches insights for a widget target and renders callouts. Renders nothing when empty.
 */
export function WidgetInsightsSlot({
  widget,
  limit = 1,
  enabled = true,
  style,
}: SlotProps) {
  const { insights } = useWidgetInsights(widget, { enabled });
  if (insights.length === 0) return null;

  const cards = insights.slice(0, Math.max(1, limit));
  return (
    <View style={[styles.stack, style]}>
      {cards.map((card) => (
        <WidgetInsightCallout key={card.id} card={card} widget={widget} />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  stack: {
    gap: spacing.sm,
  },
});
